import styled from 'styled-components/macro';
import {useCallback} from 'react';
import FieldLabel from "./field_label";
import {themecolors} from "../utils/themecolors";

export const BareTextField = ({className, id, label, value, onChange, type='text', ...props}) => {
    const handleChange = useCallback((event) => {
        onChange(event.currentTarget.value);
    }, [onChange]);
    return (
        <div className={className}>
            {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
            <input id={id} type={type} value={value} onChange={handleChange} {...props} />
        </div>
    );
};

const TextField = styled(BareTextField)`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  input {
    border: ${({theme, form}) => theme.color.name === 'dark' ? `1px solid ${theme.dark_border}` : `1px solid ${form ? '#e2e8f0' : '#ddd'}`};
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    ${({theme}) => `
        color: ${theme.control.color};
        background-color: ${theme.color.name === 'dark' ? 'inherit' : themecolors.pure_white};
    `}
  }
`;

export default TextField;
